<svg
  attr.width="{{ width }}"
  attr.height="{{ height }}"
  xmlns="http://www.w3.org/2000/svg"
  attr.class="icon-{{ name }}"
>
  <use attr.href="#{{ name }}"></use>
</svg>
